import { createTheme } from '@mui/material/styles';

export const themes = createTheme({
  typography: {
    fontFamily: 'Roboto',
    button: {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  palette: {
    primary: {
      main: '#4EA381',
    },
    secondary: {
      main: '#FFFFFF',
    },
    error: {
      main: '#FF0000',
    },
    info: {
      main: '#373867',
    },
  },
});
